// extracted by mini-css-extract-plugin
module.exports = {"copyBlock":"CopyBlock_copyBlock__ppNsy","input":"CopyBlock_input__rWsI9"};